// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3nxW8","info":"PatientInfo_info__1Xn9U"};